<template>
  <GmapMap
    ref="map"
    :center="mapSettings.center"
    :zoom="mapSettings.zoom"
    :options="mapStyle"
  >
    <GmapMarker
      v-for="r in businesses"
      v-show="r.hide_address === 0"
      :key="r.id"
      :position="getPosition(r)"
      :clickable="true"
      :draggable="false"
      :icon="
        r.is_member
          ? '/img/icon/map-marker-member.svg'
          : '/img/icon/map-marker.svg'
      "
      :class="{ 'is-active': activeBusiness === activeBusiness.id }"
      :optimized="false"
      @click="handleMarkerClicked(r)"
    />

    <GmapInfoWindow
      :options="infoWindowOptions"
      :position="infoWindowPosition"
      :opened="infoWindowOpened"
      @closeclick="handleInfoWindowClose"
    >
      <div class="google-map__info-window">
        <a
          :href="activeBusiness.route"
          class="googlemap__link"
        ><h2 class="google-map__heading google-map__heading--h2">
          {{ activeBusiness.name }}
        </h2></a>
        <p class="google-map__paragraph">
          <span
            v-if="activeBusiness.address_1"
          >{{ activeBusiness.address_1 }},
          </span>
          <span v-if="activeBusiness.address_2">{{
            activeBusiness.address_2
          }}</span>
          <span v-if="activeBusiness.city">{{ activeBusiness.city }},</span>
          <span
            v-if="activeBusiness.state_province"
          >{{ activeBusiness.state_province }},</span>
          <span v-if="activeBusiness.zip_postal_code">{{
            activeBusiness.zip_postal_code
          }}</span>
        </p>
      </div>
    </GmapInfoWindow>
  </GmapMap>
</template>

<script>
import mapStylesJson from '../utils/map-styles.json';
import Stickyfill from 'stickyfilljs';

export default {
  props: {
    businesses: { required: true, type: Array },
  },
  data() {
    return {
      loading: true,
      infoWindowOptions: {
        pixelOffset: {
          width: 0,
          height: -35,
        },
      },
      mapStyle: {
        mapTypeControl: false,
        streetViewControl: false,
        clickableIcons: false,
        styles: mapStylesJson,
      },
      mapSettings: {
        center: { lat: 49.895077, lng: -97.138451 },
        zoom: 10,
      },
      activeBusiness: {},
      infoWindowOpened: false,
    };
  },
  computed: {
    infoWindowPosition() {
      return {
        lat: parseFloat(this.activeBusiness.lat),
        lng: parseFloat(this.activeBusiness.lng),
      };
    },
  },
  watch: {
    $props: {
      handler() {
        this.fitBounds();
      },
      deep: true,
      immediate: false,
    },
  },
  mounted() {
    var elements = document.querySelectorAll('.google-map');
    Stickyfill.add(elements);
    this.fitBounds();
  },
  methods: {
    getPosition(r) {
      return {
        lat: parseFloat(r.lat),
        lng: parseFloat(r.lng),
      };
    },
    handleMarkerClicked(r) {
      this.activeBusiness = r;
      this.infoWindowOpened = true;
      this.$emit('updateActiveBusiness', r);
    },
    handleInfoWindowClose() {
      this.activeBusiness = {};
      this.infoWindowOpened = false;
      this.$emit('updateActiveBusiness', null);
    },
    fitBounds() {
      this.$refs.map.$mapPromise.then(() => {
        const bounds = new window.google.maps.LatLngBounds();
        if (this.businesses.length >= 1) {
          this.businesses.map((business) => {
            bounds.extend(
              new window.google.maps.LatLng(
                parseFloat(business.lat),
                parseFloat(business.lng),
              ),
            );
          });
          this.$refs.map.fitBounds(bounds);
        } else {
          if (this.businesses[0]) {
            this.mapSettings.center.lat = parseFloat(this.businesses[0].lat);
            this.mapSettings.center.lng = parseFloat(this.businesses[0].lng);
            this.mapSettings.zoom = 12;
          }
        }
      });
    },
  },
};
</script>
